import { fetchQuery } from 'relay-runtime';
import environment from 'shared/relay/environment';
import query from './success.query';

const getUpdatedPackageInfo = (packageId, onSuccess, onFailure) => {
  const variables = {
    packageId
  };

  return fetchQuery(environment, query, variables)
    .then(response => {
      if (response.privatePackageTracker) {
        return onSuccess(response.privatePackageTracker);
      }
      return onFailure();
    })
    .catch(() => {
      return onFailure();
    });
};

export default getUpdatedPackageInfo;
